
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/pizzeria",
      function () {
        return require("private-next-pages/outlet/pizzeria.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/pizzeria"])
      });
    }
  